// extracted by mini-css-extract-plugin
export default {"base":"components-MainMenu-themes-BAS-RD3-styles__base--ZWhmv"};